import React, { memo } from "react";
import { Progress } from "antd";
import Modal from "./Modal";
import "./styles/scss/UpdateProcess.scss";
import logo from "../styles/scss/img/common/logo.png";

function App(props) {
	const { isShow, percent } = props;

	return (
		<Modal className="popup-update-process" visible={isShow} hideClose={true}>
			<div className="title">正在更新</div>
			<img src={logo} width={100} alt="" />
			<Progress percent={percent} strokeColor="#72ff6f" showInfo={false} />
			<div className="percent">{percent}%</div>
		</Modal>
	);
}

export default memo(App);
